import { useMemo, useState, useEffect } from "react";
import { TextField } from "@mui/material";

export function TextInput({ 
  value, 
  onChange, 
  onBlur,
  onValidationChange,
  required = false,
  fullWidth = true,
  label,
  disabled = false,
  autoComplete,
  ...props 
}) {
  const [touched, setTouched] = useState(false);

  const error = useMemo(() => {
    if (!touched || disabled) return "";
    
    const trimmedValue = value.trim();
    if (required && !trimmedValue) return `${label} is required.`;
    
    return "";
  }, [value, touched, disabled, required, label]);

  const isValid = useMemo(() => {
    if (disabled) return true;
    const trimmedValue = value.trim();
    return !required || !!trimmedValue;
  }, [value, disabled, required]);

  // Notify parent of validation state changes
  useEffect(() => {
    onValidationChange?.(isValid);
  }, [isValid, onValidationChange]);

  const handleChange = (ev) => {
    onChange?.(ev.target.value);
  };

  const handleBlur = (ev) => {
    setTouched(true);
    const trimmedValue = ev.target.value.trim();
    onChange?.(trimmedValue);
    onBlur?.(trimmedValue);
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={Boolean(error)}
      helperText={error}
      required={required}
      fullWidth={fullWidth}
      disabled={disabled}
      autoComplete={autoComplete}
      variant="outlined"
      {...props}
    />
  );
}